import { seedRandom } from './rng';

/**
 * Returns a shuffled copy of ids, optionally using a deterministic seed.
 */
export function shuffleIds(ids: string[], seed?: number): string[] {
  const arr = [...ids];
  const rng = seedRandom(seed);
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
